import React, { useContext } from 'react';
import { PERMISSIONS, PermissionsContext } from 'contexts/PermissionsContext';
import { ApMenu, ApMenuItem, ApButtonIcon } from '@alixpartners/ui-components';
import { Text, Wrapper } from './ContextualMenu.styles';

export const ContextualMenu = ({
	hasWritePermissions,
	onChangeStatus,
	onViewTransactions,
	onShowTopVendors,
	hasTrackPermissions,
	setTarget,
	moveToBin,
	onChangeCategorisation,
	toggleMenu,
	isOpen,
	onClose,
	isVendorLibrary,
}) => {
	const { permissions } = useContext(PermissionsContext);
	const isMoveToBinPermission =
		permissions && permissions.includes(PERMISSIONS.TransactionsWrite);
	return (
		<Wrapper>
			<ApMenu
				onClose={onClose}
				isOpen={isOpen}
				toggleMenu={toggleMenu}
				placement="bottom-start"
				button={
					<ApButtonIcon
						iconName="outline_more_vert"
						onClick={e => e.stopPropagation()}
					/>
				}
			>
				{!isVendorLibrary && (
					<ApMenuItem onClick={onViewTransactions}>
						<Text>View Transactions</Text>
					</ApMenuItem>
				)}
				{hasWritePermissions &&
					onChangeStatus && (
						<ApMenuItem onClick={onChangeStatus}>
							<Text>Change status</Text>
						</ApMenuItem>
					)}
				{onChangeCategorisation && (
					<ApMenuItem onClick={onChangeCategorisation}>
						<Text>Change categorisation</Text>
					</ApMenuItem>
				)}
				{hasTrackPermissions &&
					setTarget && (
						<ApMenuItem onClick={setTarget}>
							<Text>Set target</Text>
						</ApMenuItem>
					)}
				{onShowTopVendors && (
					<ApMenuItem onClick={onShowTopVendors}>
						<Text>Top vendors</Text>
					</ApMenuItem>
				)}

				{moveToBin &&
					isMoveToBinPermission && (
						<ApMenuItem onClick={moveToBin}>
							<Text>Move to bin</Text>
						</ApMenuItem>
					)}
			</ApMenu>
		</Wrapper>
	);
};

export default ContextualMenu;
